import { logger } from '@azure/storage-blob';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useTheme,
} from '@mui/material';

import { UserApi } from '@/api';
import { IReleaseNote } from '@/models';
import { useUserStore } from '@/store';

interface Props {
  release: IReleaseNote;
  onClose: () => void;
}

export const ReleaseNotePopup = ({ release, onClose }: Props) => {
  const theme = useTheme();
  const { user } = useUserStore();

  const markAsSeen = async () => {
    try {
      if (user?._id && release?.version) {
        await UserApi.updateLastSeenReleaseVersion(user._id, release.version);
      }
    } catch (err) {
      logger.error('Failed to update last seen release version', err);
    }
  };

  const handleIgnore = async () => {
    await markAsSeen();
    onClose();
  };

  const handleView = async () => {
    await markAsSeen();
    window.open('/help/release-notes', '_blank');
    onClose();
  };

  return (
    <Dialog open onClose={handleIgnore}>
      <DialogTitle
        sx={{
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
        }}
      >
        New Version Available
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
        <Typography color="textPrimary">
          A new version of the system has been released. Would you like to view
          the release notes?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: theme.palette.background.default }}>
        <Button onClick={handleIgnore} color="inherit">
          Ignore
        </Button>
        <Button onClick={handleView} variant="contained" color="primary">
          View Release Notes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
